<template>
    <page-title
        title="お知らせ"
        icon="bi-chat-right-text"
    >
    </page-title>

    <inline-loader v-if="articles_loading"></inline-loader>
    <template v-else>
        <template v-if="articles.length">
            <div class="px-4">
                <ul class="p-0 m-0 mb-3" style="list-style: none;">
                    <template v-for="article in articles" :key="article">
                        <li class="d-flex py-3 article-list justify-content-between">
                            <div class="d-flex align-items-center">
                                <div style="margin-right: 5rem;">
                                    <p class="mb-0" style="color: var(--bs-gray-600)">{{ article.article_date_display }}</p>
                                </div>
                                <div
                                    class="underline"
                                    style="color: var(--bs-primary);"
                                >
                                    <p class="mb-0" style="font-size: 17px;">{{ article.article_title }}</p>
                                </div>
                            </div>
                            <div>
                                <button-go-view :linkTo="{ name: 'PageArticle', params: {id: article.article_id} }" />
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
            <paginator :meta="paginator" @move="getArticles"></paginator>
        </template>
        <alert-no-record v-else text="お知らせはありません"></alert-no-record>

    </template>
</template>

<script>
import AlertNoRecord from '@/shared/components/design/AlertNoRecord';
import PageTitle from '@/shared/components/design/PageTitle.vue';
import Article from '@/shared/models/entities/article.js';
import InlineLoader from '@/shared/components/tool/InlineLoader';
import Paginator from '@/shared/components/tool/Paginator';
import ButtonGoView from '@/shared/components/design/buttons/ButtonGoView.vue';

export default {
    name: 'PageHome',
    components: {
        AlertNoRecord,
        PageTitle,
        InlineLoader,
        Paginator,
        ButtonGoView,
    },
    data: () => {
        return {
            articles_loading: false,
            paginator: {},
            articles: []
        }
    },
    mounted() {
        this.getArticles();
    },
    methods: {
        displayArticle(article_id) {
            this.$router.push({name: 'PageArticle', params: {id: article_id}});
        },
        //お知らせ一覧取得
        getArticles(page = 1) {
            this.articles_loading = true;

            this.$http.get('/distributor/article', {
                params: {
                    'page': page,
                }
            })
            .then(response => {
                this.articles.splice(0);

                for (let row of response.data.data) {
                    this.articles.push(new Article(row));
                }

                this.paginator = response.data.meta;
            })
            .finally(() => {
                this.articles_loading = false;
            });
        },
    },
}
</script>

<style scoped>
.article-list {border-bottom: 1px solid var(--bs-gray-300);}
.article-list:last-child {border-bottom: none;}
</style>
